import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import { PreviewWrapperProps } from '@wix/editor-elements-types';
import { AudioPlayerDefinition, AudioPlayerProps } from '../AudioPlayer.types';
import { props as viewerPropsMapper } from './AudioPlayer.mapper';

const props = composeMapper<
  PreviewWrapperProps<AudioPlayerProps>,
  AudioPlayerDefinition
>()(
  viewerPropsMapper,
  { add: ['isPlayingAllowed', 'shouldResetComponent'] },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    const { isPlayingAllowed, shouldResetComponent } = deps;
    return {
      ...viewerProps,
      autoPlay: isPlayingAllowed && viewerProps.autoPlay,
      previewWrapperProps: {
        shouldResetComponent,
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
